import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-integration-dialog-solutiondeploying',
  templateUrl: './dialog-solutiondeploying.component.html'
})
export class DialogSolutionDeployingComponent implements OnInit {
  public formPermissions: FormGroup;
  public disableGrantSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogSolutionDeployingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder  
  ) { }

  ngOnInit() {
  }
}
